import * as React from 'react';
import type { AssetRegistry } from 'owa-timestream-asset-sdk-types';

const AssetRegistryContext = React.createContext<AssetRegistry>({
    functionalAssets: [],
    toolboxAssets: [],
    pastePrecedence: [],
    nonToolboxAssets: [],
    menuAssets: [],
});

AssetRegistryContext.displayName = 'AssetRegistryContext';

export const AssetRegistryProvider = AssetRegistryContext.Provider;

/**
 * Hook that return the registered toolbox assets
 */
export function useAssetRegistry() {
    return React.useContext(AssetRegistryContext);
}
